import { xssSanitizeContent } from '@maisaedu/xss_sanitize/src/sanitizer/xss.sanitize.js';

export default {
  name  : 'TextSafe',
  props : {
    tag: {
      type    : String,
      default : 'span'
    },
    text: {
      type     : String,
      required : true
    },
    sanitize: {
      type    : Boolean,
      default : true
    }
  },
  data() {
    return ({
      content: ''
    });
  },
  created() {
    this.content = this.sanitize ? xssSanitizeContent(this.text) : this.text;
  }
};
